import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GoogleMapReact from 'google-map-react';
import isEqual from 'lodash/isEqual';
import MapHelper from 'components/common/helpers/MapHelper';
import { classNameOfMarker }
  from 'components/common/helpers/jumpingMarkerDataHelper';
import { GOOGLE_MAPS_API } from 'components/windowEnvs';

const Marker = ({ icon, label, className }) => (
  <div className={className} title={label}>
    <FontAwesomeIcon
      icon={['fas', `${icon}`]}
    //transform={{ rotate: -45 }}
    />
  </div>
);

class SimpleMap extends Component {
  constructor(props) {
    super(props);
    this.map = null;
    this.maps = null;
  }

  static defaultProps = {
    center: {
      lat: 60.04,
      lng: 10.90
    },
    zoom: 10
  };

  componentDidUpdate(prevProps) {
    if (this.props.markers.length > 0 && prevProps.markers.length === 0) {
      this.fitBoundsOfMap();
    }

    var changed = this.jumpingMarkersHasChanged(prevProps);
    if (changed) {
      this.fitBoundsOnJumpingMarker();
    }
  }

  jumpingMarkersHasChanged = (prevProps) => {
    if (this.props.jumpingMarkers) {
      var jm = this.props.jumpingMarkers.filter((obj) => obj !== null);
      var prevJm = prevProps.jumpingMarkers.filter((obj) => obj !== null);
      if (jm.length !== prevJm.length) {
        return true;
      } else {
        if (jm.length === 0) {
          return false;
        }
        if (jm.length === 1) {
          return !isEqual(jm[0], prevJm[0]);
        }
        if (jm.length === 2) {
          return !(isEqual(jm[0], prevJm[0]) && isEqual(jm[1], prevJm[1]));
        }
      }
    } else {
      return false;
    }
  }

  getMapOptions = (maps) => {
    return {
      clickableIcons: false,
      disableDoubleClickZoom: true,
      fullscreenControl: false,
      minZoom: 8,
      scaleControl: true,
      streetViewControl: false,
      zoomControl: false,
      zoomControlOptions: {
        position: maps.ControlPosition.LEFT_BOTTOM
      },
    };
  }

  renderMarkers = () => {
    var counter = 0;
    var results = [];
    if (this.props.markers) {
      const { markers } = this.props;
      for (var i = 0; i < markers.length; i++) {
        var marker = markers[i];
        results.push(
          <Marker
            key={++counter}
            className={classNameOfMarker(marker)}
            {...marker}
          />
        )
      }
    }
    if (this.props.jumpingMarkers) {
      for (var m = 0; m < this.props.jumpingMarkers.length; m++) {
        var jumpingMarker = this.props.jumpingMarkers[m];
        if (jumpingMarker) {
          results.push(
            <Marker
              key={++counter}
              className={classNameOfMarker(jumpingMarker)}
              {...jumpingMarker}
            />
          );
        }
      }
    }
    return results;
  }

  onChildClick = (key, childProps) => {
    if (this.props.onChildClick) {
      this.props.onChildClick(childProps);
    }
  }

  // https://github.com/google-map-react/google-map-react-examples/blob/master/src/examples/Main.js#L40
  apiIsLoaded = (map, maps) => {
    this.map = map;
    this.maps = maps;

    //draw rectangle - for DEV purpose
    // var bounds = new this.maps.LatLngBounds(
    //   new this.maps.LatLng('59.287194', '9.793986'),
    //   new this.maps.LatLng('60.093832', '11.342898'),
    // );
    // var rectangle = new this.maps.Rectangle({
    //   bounds: bounds, // here my bounds!
    //   fillColor: '#00FF00',
    //   strokeColor: 'red',
    //   draggable: true,
    //   editable: true,
    // });
    // rectangle.setMap(map);

    //draw circle - for DEV purpose
    // var circle = new google.maps.Circle({
    //   strokeColor: "#FF0000",
    //   strokeOpacity: 0.8,
    //   strokeWeight: 2,
    //   fillColor: "#FF0000",
    //   fillOpacity: 0.35,
    //   map: map,
    //   center: {
    //     lat: 59.754145,
    //     lng: 10.497871
    //   },
    //   radius: 54 * 1000
    // });

    if (this.props.markers.length > 0) {
      this.fitBoundsOfMap();
    }
    this.fitBoundsOnJumpingMarker();
  }

  fitBoundsOfMap = () => {
    var markers = this.props.markers;
    if (markers.length > 0) {
      if (markers.length === 1) {
        var m = markers[0];
        this.map.setCenter({ lat: m.lat - 0.001, lng: m.lng });
        this.map.setZoom(13);
      } else {
        const bounds = new this.maps.LatLngBounds();
        markers.forEach((place) => {
          bounds.extend(new this.maps.LatLng(
            place.lat,
            place.lng,
          ));
        });
        this.map.fitBounds(bounds);
      }
    }
  };

  fitBoundsOnJumpingMarker = () => {
    const { jumpingMarkers } = this.props;
    if (jumpingMarkers) {
      const bounds = new this.maps.LatLngBounds();
      var number = 0;
      for (var i = 0; i < jumpingMarkers.length; i++) {
        var jm = jumpingMarkers[i];
        if (jm) {
          if (!jm.lat || !jm.lng) {
            continue;
          }
          number++;
          bounds.extend(new this.maps.LatLng(
            jm.lat,
            jm.lng
          ));
        }
      }
      if (number > 0) {
        this.map.fitBounds(bounds);
      }
      if (number === 1) {
        var jm = jumpingMarkers[0];
        this.map.setCenter({ lat: jm.lat - 0.001, lng: jm.lng });
        this.map.setZoom(16);
      } else if (number === 2) {
        var helper = new MapHelper()
        var zoom = helper.getZoomForTwoMarkers(jumpingMarkers[0], jumpingMarkers[1])
        this.map.setZoom(zoom);
      }
    }
  }

  render() {
    return (
      // Important! Always set the container height explicitly
      // i've moved height to style:
      //   iOS - height: calc(100vh - 50px);
      // > 640 - height: 100vh
      <div style={{ width: '100%' }} className="wrapper-map-places">
        <GoogleMapReact
          bootstrapURLKeys={{ key: GOOGLE_MAPS_API }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
          options={this.getMapOptions}
          onChildClick={this.onChildClick}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => this.apiIsLoaded(map, maps)}
        >
          {this.renderMarkers()}
        </GoogleMapReact>
      </div>
    );
  }
}

export default SimpleMap;
